/**
 * i18n configuration for internationalization.
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from './locales/en.json';
import frTranslations from './locales/fr.json';
import deTranslations from './locales/de.json';
import itTranslations from './locales/it.json';
import esTranslations from './locales/es.json';
import nlTranslations from './locales/nl.json';
import plTranslations from './locales/pl.json';
import svTranslations from './locales/sv.json';
import daTranslations from './locales/da.json';
import fiTranslations from './locales/fi.json';
import noTranslations from './locales/no.json';
import ptTranslations from './locales/pt.json';
import elTranslations from './locales/el.json';
import csTranslations from './locales/cs.json';
import srTranslations from './locales/sr.json';
import trTranslations from './locales/tr.json';
import faTranslations from './locales/fa.json';
import arTranslations from './locales/ar.json';
import kuTranslations from './locales/ku.json';
import heTranslations from './locales/he.json';
import jaTranslations from './locales/ja.json';
import koTranslations from './locales/ko.json';
import zhTranslations from './locales/zh.json';
import hiTranslations from './locales/hi.json';
import ruTranslations from './locales/ru.json';
import ukTranslations from './locales/uk.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations,
      },
      fr: {
        translation: frTranslations,
      },
      de: {
        translation: deTranslations,
      },
      it: {
        translation: itTranslations,
      },
      es: {
        translation: esTranslations,
      },
      nl: {
        translation: nlTranslations,
      },
      pl: {
        translation: plTranslations,
      },
      sv: {
        translation: svTranslations,
      },
      da: {
        translation: daTranslations,
      },
      fi: {
        translation: fiTranslations,
      },
      no: {
        translation: noTranslations,
      },
      pt: {
        translation: ptTranslations,
      },
      el: {
        translation: elTranslations,
      },
      cs: {
        translation: csTranslations,
      },
      sr: {
        translation: srTranslations,
      },
      tr: {
        translation: trTranslations,
      },
      fa: {
        translation: faTranslations,
      },
      ar: {
        translation: arTranslations,
      },
      ku: {
        translation: kuTranslations,
      },
      he: {
        translation: heTranslations,
      },
      ja: {
        translation: jaTranslations,
      },
      ko: {
        translation: koTranslations,
      },
      zh: {
        translation: zhTranslations,
      },
      hi: {
        translation: hiTranslations,
      },
      ru: {
        translation: ruTranslations,
      },
      uk: {
        translation: ukTranslations,
      },
    },
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
